import { connect } from 'react-redux';
import {
    getAppointmentDetailsBegin,
    getAppointmentCommentListBegin,
    addAppointmentCommentBegin,
    addAppointmentInspectionBegin,
    deleteAppointmentInspectionBegin,
    setAppointmentPersonList,
    getAppointmentTypeListBegin,
} from '../../store/actions/person.actions';
import {
    getAppointmentDetail,
    getAppointmentEditForm,
    getAppointmentCommentList,
    getAppointmentDetailLoading,
    getAppointmentCommentLoading,
    getLoadMoreAppointmentCommentList,
    getAppointmentLicenseColumnFields,
} from '../../store/selectors/person.selectors';
import { getAppointmentInspectionListBegin } from '../../store/actions/person.actions';
import { getUserListBegin, setActiveTab } from '../../store/actions/license.actions';
import AppointmentDetailTabs from './AppointmentDetailTabs';

import { getLoadMoreAppointmentInspection } from '../../store/selectors/person.selectors';

import { getAppointmentInspectionLoading, getAppointmentInspectionList } from '../../store/selectors/person.selectors';
import {
    getFilteredLicensesForAppointmentsBegin,
    getLinkedLicensesBegin,
    addLicensesForAppointmentsBegin,
} from '../../store/actions/calendar.actions';
import {
    getFilteredLicensesForAppointments,
    getFilteredLicensesLoadingStatus,
    getSpecificLicenses,
    getAppointmentLicensesLoading,
} from '../../store/selectors/calendar.selectors';
import { removeLicenseFromAppointmentBegin } from '../../store/actions/calendar.actions';

const mapStateToProps = (state: any) => {
    const isLoading = getAppointmentDetailLoading(state);
    const editForm = getAppointmentEditForm(state);
    const appointmentDetail = getAppointmentDetail(state);
    const appointmentLicenses = getSpecificLicenses(state);
    const appointmentLicensesLoading = getAppointmentLicensesLoading(state);
    const appointmentInspectionsLoading = getAppointmentInspectionLoading(state);
    const appointmentCommentList = getAppointmentCommentList(state);
    const appointmentInspectionsList = getAppointmentInspectionList(state);
    const hasMoreAppointmentInspections = getLoadMoreAppointmentInspection(state);
    const hasMoreComment = getLoadMoreAppointmentCommentList(state);
    const isAddAppointmentCommentLoading = getAppointmentCommentLoading(state);
    const personLicenses = getFilteredLicensesForAppointments(state);
    const personLicensesLoadingStatus = getFilteredLicensesLoadingStatus(state);
    const appointmentLicenseColumnFields = getAppointmentLicenseColumnFields(state);

    return {
        editForm,
        isLoading,
        hasMoreComment,
        personLicenses,
        appointmentDetail,
        appointmentLicenses,
        appointmentCommentList,
        appointmentLicensesLoading,
        appointmentInspectionsList,
        personLicensesLoadingStatus,
        appointmentInspectionsLoading,
        hasMoreAppointmentInspections,
        isAddAppointmentCommentLoading,
        appointmentLicenseColumnFields,
    };
};

const mapDispatchToProps = {
    getAppointmentDetails: getAppointmentDetailsBegin,
    setActiveTab: setActiveTab,
    getAppointmentCommentsList: getAppointmentCommentListBegin,
    addAppointmentComment: addAppointmentCommentBegin,
    getAppointmentInspectionList: getAppointmentInspectionListBegin,
    addAppointmentInspection: addAppointmentInspectionBegin,
    deleteAppoinmentInspection: deleteAppointmentInspectionBegin,
    getUserList: getUserListBegin,
    getLinkedLicensesForAppointments: getLinkedLicensesBegin,
    addLicensesForAppointmentsBegin,
    setAppointmentPersonList,
    getFilteredLicensesForAppointments: getFilteredLicensesForAppointmentsBegin,
    removeLicenseFromAppointment: removeLicenseFromAppointmentBegin,
    getAppointmentTypeList: getAppointmentTypeListBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentDetailTabs);
